import { Component, Input, Inject } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { WatchAccountService } from '../../../services/watch-account.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DOCUMENT } from '@angular/common';
import { Subscription, Subject } from 'rxjs';

@Component({
  selector: '[modal-create-custom-inbox]',
  template: require('./modal-create-custom-inbox.component.pug'),
  styles: [require('./modal-create-custom-inbox.component.css').toString()],
})
export class ModalCreateCustomInboxComponent {
  @Input()
  data: any;

  public reason: Subject<any>;

  // params from guest page
  accountId: string = null;
  source: string = null;

  error = null;
  errorTestSending = null;
  errorTestReceiving = null;
  successTestReceiving = null;
  successTestSending = null;

  // -------------------------------------------------------------------
  constructor(
    @Inject(DOCUMENT) private document: any,
    public bsModalRef: BsModalRef,
    private accountService: AccountService,
    private watchAccount: WatchAccountService,
  ) {
    this.reason = new Subject();
  }

  // -------------------------------------------------------------------
  ngOnInit() {}

  // -------------------------------------------------------------------
  ngOnDestroy() {}

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  getAccountId() {
    if (this.accountId && this.source) return this.accountId;
    
    return this.watchAccount.accountId().getValue();
  }

  name;
  emailAddress;

  sendAddress;
  sendPort;
  sendLogin;
  sendPassword;

  receiveAddress;
  receivePort;
  receiveLogin;
  receivePassword;

  // -------------------------------------------------------------------
  allFilled() {
    if (!this.emailAddress) return false;
    if (!this.name) return false;

    if (!this.sendAddress) return false;
    if (!this.sendPort) return false;
    if (!this.sendLogin) return false;
    if (!this.sendPassword) return false;

    if (!this.receiveAddress) return false;
    if (!this.receivePort) return false;
    if (!this.receiveLogin) return false;
    if (!this.receivePassword) return false;

    return true;
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.error = null;

    if (!this.successTestReceiving || !this.successTestSending) {
      const error = "You must successfully test you sending and receiving credentials before you can add this inbox."
      this.error = error;
      onfailure(error);
      return;
    }

    this.accountService.addCustomInbox(
      this.getAccountId(),
      this.name,
      this.emailAddress,
      this.sendAddress,
      this.sendPort,
      this.sendLogin,
      this.sendPassword,
      this.receiveAddress,
      this.receivePort,
      this.receiveLogin,
      this.receivePassword,
      this.source,
      res => {
        this.bsModalRef.hide();
        this.reason.next(res);
        onsuccess();
      },
      error => {
        this.error = error;
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  allFilledSending() {
    if (!this.emailAddress) return false;

    if (!this.sendAddress) return false;
    if (!this.sendPort) return false;
    if (!this.sendLogin) return false;
    if (!this.sendPassword) return false;

    return true;
  }

  // -------------------------------------------------------------------
  testSending(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.errorTestSending = null;
    this.successTestSending = null;

    this.accountService.testCustomInboxSending(
      this.getAccountId(),
      this.emailAddress,
      this.sendAddress,
      this.sendPort,
      this.sendLogin,
      this.sendPassword,
      null,
      this.source,
      res => {
        this.successTestSending = 'Your configuration is correct';
        onsuccess();
      },
      error => {
        this.errorTestSending = error;
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  allFilledReceiving() {
    if (!this.emailAddress) return false;

    if (!this.receiveAddress) return false;
    if (!this.receivePort) return false;
    if (!this.receiveLogin) return false;
    if (!this.receivePassword) return false;

    return true;
  }

  // -------------------------------------------------------------------
  testReceiving(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.errorTestReceiving = null;
    this.successTestReceiving = null;
    this.accountService.testCustomInboxReceiving(
      this.getAccountId(),
      this.emailAddress,
      this.receiveAddress,
      this.receivePort,
      this.receiveLogin,
      this.receivePassword,
      null,
      this.source,
      res => {
        this.successTestReceiving = 'Your configuration is correct';
        onsuccess();
      },
      error => {
        this.errorTestReceiving = error;
        onfailure(error);
      },
    );
  }
}
